import { taskDrawer } from 'app/redux/reducers/Drawer/drawer.reducer';
import { drawerStore } from 'app/redux/rootReducer';

export function selectTaskDrawer(state) {
    return state[drawerStore][taskDrawer];
}
